module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/freeze.js
// module id = 399
// module chunks = 0 1